import React, { useState } from 'react';
import AUX from '../../../hoc/Aux_';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { addMeberInvite } from '../../../redux/MainAction';
import Axios from 'axios';
import Constant from '../../../Constant';
import { jwtDecode } from 'jwt-decode';
import { getDomainType } from '../../../Constant';
import RegisterSuccess from './RegisterSuccess';

const InviteRegister = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const [pass, setPass] = useState(true);
  const [Cpass, setCPass] = useState(true);

  const [registerSuccess, setRegisterSuccess] = useState(false);

  const [saveData, setSaveData] = useState({
    firstName: '',
    lastName: '',
    password: '',
    Cpassword: '',
    joiningToken: '',
    email: '',
  });

  const onChangeHandle = (e) => {
    const { name, value } = e.target;
    setSaveData({ ...saveData, [name]: value });
  };

  const decoded = jwtDecode(params?.token);

  const onSubmit = async (e) => {
    e.preventDefault();

    if (saveData?.firstName === '') {
      toast.error('Please add first name!', {
        position: 'top-right',
      });
      return false;
    } else if (saveData?.lastName === '') {
      toast.error('Please add last name!', {
        position: 'top-right',
      });
      return false;
    } else if (!decoded?.email && !saveData?.email) {
      toast.error('Please add email!', {
        position: 'top-right',
      });
      console.log(saveData?.email);
      return false;
    } else if (
      saveData?.email &&
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(saveData?.email || '')
    ) {
      toast.error('Please add a valid email!', {
        position: 'top-right',
      });
      return false;
    } else if (saveData?.password === '') {
      toast.error('Please add password!', {
        position: 'top-right',
      });
      return false;
    } else if (saveData?.password !== saveData?.Cpassword) {
      toast.error('Passwords do not match', {
        position: 'top-right',
      });
      return false;
    }

    const data1 = {
      domainName: getDomainType(),
    };

    try {
      const response = await Axios.post(
        Constant.getAPI() + 'user/auth/domain/get',
        data1,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      if (response?.data?.data && response?.data?.data?.id) {
        const loginData = {
          domainId: response.data.data.id,
          firstName: saveData?.firstName,
          lastName: saveData?.lastName,
          email: decoded?.email || saveData?.email,
          password: saveData?.password,
          joiningToken: params?.token,
        };

        const res = await dispatch(addMeberInvite(loginData));

        if (res?.success) {
          setRegisterSuccess(true);
        } else {
          console.log(res?.success);
        }
      }
    } catch (error) {
      console.error(
        'Error submitting domain:',
        error.response ? error.response.data : error.message
      );
    }
  };

  return registerSuccess ? (
    <RegisterSuccess />
  ) : (
    <AUX>
      <div
        className="accountbg"
        style={{
          background: "url('assets/images/stardust.png')",
          backgroundSize: 'cover',
        }}
      ></div>
      <div className="wrapper-page">
        <div className="card">
          <div className="card-body">
            <div className="p-3">
              <div className="d-flex flex-column">
                <span className="text-muted font-16 text-center">
                  You have been invited to join the
                </span>
                <span className="text-muted font-16 text-center">
                  <b>{decoded?.workspaceName}</b> workspace, by{' '}
                  <b>{decoded?.ownerName}</b>
                </span>
              </div>

              <h3 className="font-30  text-center">Set up your profile</h3>

              <form className="form-horizontal m-t-30" action="/">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    name="firstName"
                    value={saveData?.firstName}
                    onChange={onChangeHandle}
                    placeholder="Enter first name"
                  />
                </div>

                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    id="user"
                    name="lastName"
                    value={saveData?.lastName}
                    onChange={onChangeHandle}
                    placeholder="Enter last name"
                  />
                </div>
                <div className="form-group">
                  <input
                    type="email"
                    className="form-control"
                    id="username"
                    name="email"
                    disabled={decoded?.email}
                    value={decoded?.email || saveData?.email}
                    onChange={onChangeHandle}
                    placeholder="Enter email"
                  />
                </div>

                <div
                  className="form-group d-flex align-items-center border "
                  style={{ gap: '10px', borderRadius: '4px' }}
                >
                  <input
                    type={pass ? 'password' : 'text'}
                    className="form-control input_pass"
                    id="userpassword"
                    placeholder="Enter password"
                    name="password"
                    value={saveData?.password}
                    onChange={onChangeHandle}
                  />
                  {pass ? (
                    <i
                      className="mdi mdi-eye-off text-center pass_icon mr-2"
                      onClick={() => setPass(!pass)}
                    ></i>
                  ) : (
                    <i
                      className="mdi mdi-eye text-center pass_icon mr-2"
                      onClick={() => setPass(!pass)}
                    ></i>
                  )}
                </div>
                <div
                  className="form-group d-flex align-items-center border "
                  style={{ gap: '10px', borderRadius: '4px' }}
                >
                  <input
                    type={Cpass ? 'password' : 'text'}
                    className="form-control input_pass"
                    id="userpassword"
                    placeholder="Enter confirm password"
                    name="Cpassword"
                    value={saveData?.Cpassword}
                    onChange={onChangeHandle}
                  />
                  {Cpass ? (
                    <i
                      className="mdi mdi-eye-off text-center pass_icon mr-2"
                      onClick={() => setCPass(!Cpass)}
                    ></i>
                  ) : (
                    <i
                      className="mdi mdi-eye text-center pass_icon mr-2"
                      onClick={() => setCPass(!Cpass)}
                    ></i>
                  )}
                </div>

                <div className="form-group row m-t-20">
                  <div className="col-sm-12">
                    <button
                      onClick={onSubmit}
                      className="btn btn-primary w-md col-sm-12 waves-effect waves-light"
                      type="submit"
                    >
                      Create Profile
                    </button>
                  </div>
                </div>

                <div className="form-group ">
                  <div className="d-flex flex-column col-12 m-t-20">
                    <span className="text-center">
                      By signing up, you agree to the
                    </span>
                    <span className="text-center">
                      <b>Terms of Service</b> and <b>Privacy Policy</b>.
                    </span>
                    {/* <Link to="pages_recoverpw" className="text-muted"><i className="mdi mdi-lock"></i> Forgot your password?</Link> */}
                  </div>
                </div>
                <div className="m-t-10 text-center">
                  <p className="text-dark">
                    © {new Date().getFullYear() - 1} -{' '}
                    {new Date().getFullYear()} Web Tracker
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </AUX>
  );
};

export default InviteRegister;
